import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CASE_DETAILS_STATE_KEY, ICaseDetailsState } from './data-access.state';

const state = createFeatureSelector<ICaseDetailsState>(CASE_DETAILS_STATE_KEY);

export const caseDetailsSelector = createSelector(state, (state1: ICaseDetailsState) => state1.caseDetails);
export const isLoading = createSelector(state, (state1: ICaseDetailsState) => state1.isLoading);
export const caseUidSelector = createSelector(state, (state1: ICaseDetailsState) => state1.caseUid);
export const officerCaseRoleSelector = createSelector(state, (state1: ICaseDetailsState) => state1.caseDetails?.officerCaseRole);

export const caseEvidenceFilesSelector = createSelector(state, (state1: ICaseDetailsState) => state1.evidenceFiles);
export const caseEvidenceFilesLoadingSelector = createSelector(state, (state1: ICaseDetailsState) => state1.evidenceFilesLoading);
export const caseEvidenceFoldersSelector = createSelector(state, (state1: ICaseDetailsState) => state1.evidenceFolders);
export const caseEvidenceFoldersLoadingSelector = createSelector(state, (state1: ICaseDetailsState) => state1.evidenceFoldersLoading);

export const caseMembersSelector = createSelector(state, (state1: ICaseDetailsState) => state1.caseMembers);
export const caseMembersLoadingSelector = createSelector(state, (state1: ICaseDetailsState) => state1.caseMembersLoading);
export const actionResult = createSelector(state, (state1: ICaseDetailsState) => state1.actionResult);
